import { render, staticRenderFns } from "./zkType.vue?vue&type=template&id=a9222a54&scoped=true"
import script from "./zkType.vue?vue&type=script&lang=js"
export * from "./zkType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9222a54",
  null
  
)

export default component.exports